import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Navigation from "./components/lifelink/Navigation";
import InstallPrompt from "./components/lifelink/InstallPWA";
import PushNotificationPrompt from "./components/lifelink/PushNotificationPrompt";
import DocumentBanner from "./components/lifelink/DocumentBanner";
import SOSWidget from "./components/lifelink/SOSWidget";
import ChatbotTriage from "./components/lifelink/ChatbotTriage";
import LandingPage from "./pages/LandingPage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import MapPage from "./pages/MapPage";
import RequestsPage from "./pages/RequestsPage";
import ProfilePage from "./pages/ProfilePage";
import AdminPage from "./pages/AdminPage";
import BackendLoginPage from "./pages/BackendLoginPage";
import PasswordResetPage from "./pages/PasswordResetPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import DocumentUploadPage from "./pages/DocumentUploadPage";
import MyRequestsPage from "./pages/MyRequestsPage";
import OperationsTVPage from "./pages/OperationsTVPage";

function AppRoutes() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const isAuthenticated = user && user !== false;
  const pathname = location.pathname;
  const isAuthPage = pathname === '/login' || pathname === '/registrazione' || pathname === '/recupera-password' || pathname.startsWith('/reset-password');
  const isBackendPage = pathname === '/backend';
  const isTVPage = pathname === '/tv' || pathname.startsWith('/tv/');
  const showNav = (isAuthenticated || isAuthPage) && !isBackendPage && !isTVPage;

  if (loading) {
    return (
      <div className="min-h-screen bg-[#E8F4FD] flex items-center justify-center">
        <div className="text-center">
          <img
            src="https://customer-assets.emergentagent.com/job_help-beacon-9/artifacts/ok1e76vb_17%20apr%202026%2C%2009_06_17.png"
            alt="LIFE LINKE"
            className="h-20 w-auto mx-auto mb-4 animate-pulse"
          />
          <div className="w-8 h-1 bg-[#FF3B30] mx-auto" />
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Only show nav for authenticated users or on auth pages */}
      {showNav && <Navigation />}
      {isAuthenticated && <DocumentBanner />}
      <Routes>
        <Route path="/" element={isAuthenticated ? <HomePage /> : <LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/registrazione" element={<RegisterPage />} />
        <Route path="/backend" element={<BackendLoginPage />} />
        <Route path="/tv" element={<OperationsTVPage />} />
        <Route path="/recupera-password" element={<PasswordResetPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/dashboard" element={isAuthenticated ? <DashboardPage /> : <LandingPage />} />
        <Route path="/mappa" element={isAuthenticated ? <MapPage /> : <LandingPage />} />
        <Route path="/richieste" element={isAuthenticated ? <RequestsPage /> : <LandingPage />} />
        <Route path="/profilo" element={isAuthenticated ? <ProfilePage /> : <LandingPage />} />
              <Route path="/le-mie-richieste" element={isAuthenticated ? <MyRequestsPage /> : <LandingPage />} />
              <Route path="/verifica-documento" element={isAuthenticated ? <DocumentUploadPage /> : <LandingPage />} />
              <Route path="/admin" element={isAuthenticated ? <AdminPage /> : <LandingPage />} />
      </Routes>
      <InstallPrompt />
      <PushNotificationPrompt />
      {isAuthenticated && !isTVPage && <SOSWidget />}
      {!isTVPage && !isBackendPage && <ChatbotTriage />}
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#FFFFFF',
            border: '1px solid #B8D4E8',
            color: '#0D1B2A',
            fontFamily: 'DM Sans, sans-serif',
            fontSize: '12px',
            letterSpacing: '0.05em',
            textTransform: 'uppercase',
          },
        }}
      />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="App min-h-screen bg-[#E8F4FD]">
            <AppRoutes />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
